import "./App.css";
import React from "react";
import Index from "./Pages/index"

function App(){
  return (
    <Index/>
  );
};

export default App;
